import ColorSwatch from './ColorSwatch'
import TextSwatch from './TextSwatch'
import { getTranslation } from '../utils/bike-schema'
import InlineSvg from './InlineSvg'

const ComponentListItem = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  component,
  active,
  option,
  hex,
  specificationClick
}) => {
  const className = [
    'velorbis-customizer-component',
    active ? 'velorbis-customizer-component-active' : ''
  ].join(' ')
  return (
    <div
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className}
      data-component={component.id}
    >
      <div className="velorbis-customizer-component-name">
        {getTranslation(component.name)}
      </div>
      {hex ? (
        <ColorSwatch hex={hex} />
      ) : (
        <TextSwatch text={option.swatch_text} />
      )}
      <div
        className="velorbis-customizer-specification"
        onMouseEnter={(e) => handleClick(e, component.id, specificationClick)}
      >
        <InlineSvg src="icons/inf" />
      </div>
    </div>
  )
}

export const handleClick = (e, id, specificationClick) => {
  e.stopPropagation()
  specificationClick(id)
}

export default ComponentListItem
